(() => {
  if (customElements.get('ashmere-final-cart')) return;
  let updating = false;
  class AshmereFinalCart extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', event => {
        const close = event.target.closest('[data-close]');
        if (close) { this.closest('cart-drawer')?.close(); return; }
        const quantity = event.target.closest('[data-quantity]');
        if (!quantity) return;
        const row = quantity.closest('[data-line-key]');
        this.mutate('cart/change.js', {id:row.dataset.lineKey, quantity:Number(quantity.dataset.quantity)}, quantity);
      });
      this.addEventListener('submit', event => {
        const form = event.target.closest('.fbt-form');
        if (!form) return;
        event.preventDefault();
        if (!form.reportValidity()) return;
        this.mutate('cart/add.js', {items:[{id:Number(new FormData(form).get('id')),quantity:1}]}, form.querySelector('button'));
      });
      this.addEventListener('change', event => {
        if (event.target.matches('.fbt-select')) {
          const option = event.target.selectedOptions[0];
          const card = event.target.closest('.fbt-card');
          card.querySelector('.fbt-new-price').textContent = option.dataset.price || '';
          const old = card.querySelector('.fbt-old-price');
          old.textContent = option.dataset.compare || '';
          old.hidden = !option.dataset.compare;
        }
        if (event.target.matches('[data-protection]')) {
          const toggle = event.target;
          const endpoint = toggle.checked ? 'cart/add.js' : 'cart/change.js';
          const payload = toggle.checked
            ? {items:[{id:Number(toggle.dataset.variant),quantity:1,properties:{_ashmere_shipping_protection:'true'}}]}
            : {id:toggle.dataset.key,quantity:0};
          this.mutate(endpoint, payload, toggle);
        }
      });
    }
    async mutate(endpoint, payload, trigger) {
      if (updating) return;
      updating = true;
      const mode = this.dataset.mode;
      const errorMessage = this.dataset.error;
      const root = (window.Shopify?.routes?.root || this.dataset.root || '/').replace(/\/?$/, '/');
      const page = document.querySelector('[data-ac-section]');
      const sections = ['cart-drawer','cart-icon-bubble'];
      if (page) sections.push(page.dataset.acSection);
      const controls = [...document.querySelectorAll('ashmere-final-cart button, ashmere-final-cart select, ashmere-final-cart input')];
      const disabled = controls.map(el => el.disabled);
      controls.forEach(el => el.disabled = true);
      document.querySelectorAll('ashmere-final-cart').forEach(el => el.setAttribute('aria-busy','true'));
      this.querySelector('.ac-error').textContent = '';
      let succeeded = false;
      try {
        const response = await fetch(root + endpoint, {
          method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({...payload,sections,sections_url:window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.errors) throw new Error(typeof result.description === 'string' ? result.description : errorMessage);
        succeeded = true;
        for (const section of sections) {
          const html = result.sections?.[section];
          if (!html) throw new Error(errorMessage);
          const doc = new DOMParser().parseFromString(html,'text/html');
          if (section === 'cart-drawer') {
            const source = doc.querySelector('#CartDrawer .ac-drawer-content');
            const target = document.querySelector('#CartDrawer .ac-drawer-content');
            if (target && source) target.innerHTML = source.innerHTML;
            const drawer = document.querySelector('cart-drawer');
            drawer?.classList.toggle('is-empty', !doc.querySelector('.ac-final .cart-item'));
          } else if (section === 'cart-icon-bubble') {
            const target = document.getElementById('cart-icon-bubble');
            const source = doc.querySelector('.shopify-section');
            if (target && source) target.innerHTML = source.innerHTML;
          } else {
            const source = doc.querySelector('[data-ac-section]');
            if (source && page) page.innerHTML = source.innerHTML;
          }
        }
        const active = document.querySelector('ashmere-final-cart[data-mode="'+mode+'"]');
        const focus = active?.querySelector('[data-close], .checkout-btn');
        focus?.focus({preventScroll:true});
        document.dispatchEvent(new CustomEvent('ashmere:cart-updated'));
      } catch (error) {
        if (succeeded) { window.location.reload(); return; }
        const active = document.querySelector('ashmere-final-cart[data-mode="'+mode+'"]') || this;
        const message = active.querySelector('.ac-error');
        message.textContent = error.message || errorMessage;
        message.focus();
        if (trigger?.matches('[data-protection]')) trigger.checked = !trigger.checked;
      } finally {
        controls.forEach((el,i) => { if(el.isConnected) el.disabled = disabled[i]; });
        document.querySelectorAll('ashmere-final-cart').forEach(el => el.removeAttribute('aria-busy'));
        updating = false;
      }
    }
  }
  customElements.define('ashmere-final-cart', AshmereFinalCart);
})();
